import Decimal from 'decimal.js';

type InstantAvailabilityReason =
  | 'no_currency_instant_rate'
  | 'no_currency_period_instant_rate'
  | 'exceeds_currency_limit'
  | 'exceeds_ticket_capacity';

export interface InstantAvailability {
  available: boolean;
  reason?: InstantAvailabilityReason;
  effectiveLimit?: string;
}

interface CheckInstantAvailabilityParams {
  instantRate: string | null | undefined;
  amount: string;
  maxInstantTransactionLimit: string;
  availableTicketAmount: string;
  availableInstantPeriods?: number[];
}

export function checkInstantAvailability({
  instantRate,
  amount,
  maxInstantTransactionLimit,
  availableTicketAmount,
  availableInstantPeriods,
}: CheckInstantAvailabilityParams): InstantAvailability {
  const amountNum = new Decimal(amount ? amount : 0);
  const maxInstantNum = new Decimal(maxInstantTransactionLimit);
  const ticketAvailableNum = new Decimal(availableTicketAmount);

  // Check 1: No instant rate exists for this currency + period
  if (!instantRate || instantRate === '0' || ticketAvailableNum.eq(0)) {
    // Differentiate between: no instant rates for currency at all vs. just not for this period
    const hasNoInstantRatesForCurrency =
      !availableInstantPeriods || availableInstantPeriods.length === 0;

    return {
      available: false,
      reason: hasNoInstantRatesForCurrency
        ? 'no_currency_instant_rate'
        : 'no_currency_period_instant_rate',
    };
  }

  // Check 2: Amount exceeds currency max instant transaction limit
  if (amountNum.gt(maxInstantNum)) {
    return {
      available: false,
      reason: 'exceeds_currency_limit',
      effectiveLimit: maxInstantTransactionLimit,
    };
  }

  // Check 3: Amount exceeds available ticket capacity
  if (amountNum.gt(ticketAvailableNum)) {
    return {
      available: false,
      reason: 'exceeds_ticket_capacity',
      effectiveLimit: availableTicketAmount,
    };
  }

  // Available
  return {
    available: true,
  };
}
